import {landing_home} from "../../../assets/images";
import styled from 'styled-components';


const HeroContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 430px;
  // width: 97%;
  overflow: hidden;
  position: relative;
  padding: 140px 20px 40px;

background:
  linear-gradient(
    to bottom,
    rgba(16, 12, 24, 0) 0%,
    rgba(58, 47, 80, 0.28) 35%,
    rgba(43, 34, 61, 0.46) 55%,
    rgba(16, 12, 24, 0.62) 100%
  ),
  url(${landing_home}) center 23% / cover no-repeat; 


  > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 640px) {
    padding: 20px 16px;
    height: 520px;
  }
`;


const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-top: 60px;
  max-width: 939px;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  @media (max-width: 991px) {
    max-width: 700px;
    gap: 28px;
  }

  @media (max-width: 640px) {
    gap: 24px;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

const MainHeading = styled.h1`
  width: 100%;
  color: #fff;
  text-align: center;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.59);
  letter-spacing: 0.2px;
  font: 700 60px/70px 'Inter', sans-serif;
  margin: 0;


  @media (max-width: 991px) {
    font-size: 48px;
    line-height: 56px;
  }

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -0.4px;
  }
`;

const Subtitle = styled.p`
  color: #fff;
  text-align: center;
  letter-spacing: -0.08px;
  font: 500 18px/160% 'Inter', sans-serif;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.61);

  @media (max-width: 640px) {
    font-size: 14px;
    line-height: 150%;
  }
`;


const Hero = ({title, subtitle}) => {

  return (
    <HeroContainer>
      <ContentWrapper>
        <TextContent>
          <MainHeading>
            {title}
          </MainHeading>
          <Subtitle>
            {subtitle}
          </Subtitle>
        </TextContent>
        <CTAButton >
           Schedule a Demo
        </CTAButton>
       
      </ContentWrapper>
    </HeroContainer>
  );
};

const CTAButton = ({ children }) => {
  return (
   <ButtonContainer onClick={() => window.open("https://calendly.com/campusinsights-info/30min", "_blank")}>
      <ButtonText1>{children}</ButtonText1>
      <IconWrapper>
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="arrow-icon"
        >
          <g clipPath="url(#clip0_356_944)">
            <path
              d="M15.5 5L14.09 6.41L18.67 11H2.5V13H18.67L14.08 17.59L15.5 19L22.5 12L15.5 5Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_356_944">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </IconWrapper>
    </ButtonContainer>
  );
};



const ButtonContainer = styled.button`
  display: flex;
  height: 48px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  background: linear-gradient(90deg, #5ea1ff 0%, #6a37e3 56.38%);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;

  @media (max-width: 640px) {
    width: 100%;
    max-width: 200px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 640px) {
    font-size: 13px;
  }

  .arrow-icon {
    width: 24px;
    height: 24px;
    aspect-ratio: 1/1;
  }
`;

const ButtonText1 = styled.span`
  color: #fff;
  text-align: center;
  letter-spacing: -0.075px;
  font: 700 15px/140% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  
  @media (max-width: 640px) {
    font-size: 13px;
  }
`;

export default Hero;
